import React, { useState, useEffect } from 'react';
import { useDispatch } from '../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../chronusStore/slice/eventsListing';
import App from './App';
import ChrFiltersLoader from '../../../../generic/Utils/ChrFiltersLoader';

const AppInitializer = props => {
  const [storePopulated, setStorePopulated] = useState(false);
  const dispatch = useDispatch();
  // Decrementing the page value since ChrPaginate index starts with 0.
  const initialState = props.data.initialState;
  if(initialState.page) initialState.page = Math.max(0, initialState.page - 1);

  useEffect(() => {
    dispatch(eventsListingActions.replaceEvents(initialState))
    setStorePopulated(true);
  }, []);

  return (
    <>
      { storePopulated ? <App { ...props } /> : <ChrFiltersLoader/> }
    </>
  )
};

export default AppInitializer;